import { type UiAwarePageConfiguration } from './types';

/**
 * Returns whether or not the provided page, defined as either a page configuration model,
 * {@link UiAwarePageConfiguration}, or the {@link ActivePageMatcher} associated with a page
 * configuration model, {@link UiAwarePageConfiguration}, is active for the provided pathname,
 * {@link string}.
 */
export const isPageActive = (
  page: NonNullable<UiAwarePageConfiguration['activeMatcher']> | UiAwarePageConfiguration,
  pathname: string,
): boolean => {
  const activeMatcher =
    typeof page === 'function' || Array.isArray(page) || page instanceof RegExp
      ? page
      : (page.activeMatcher ?? page.matcher);

  if (typeof activeMatcher === 'function') {
    return activeMatcher(pathname);
  } else if (Array.isArray(activeMatcher)) {
    return activeMatcher.some(matcher => matcher.test(pathname));
  }
  return activeMatcher.test(pathname);
};
